module.exports = __webpack_public_path__ + "img/team-pros.af6cf9fa.svg";